import {
  CreateDevelopmentNoteCommand,
  DevelopmentNoteDto,
} from "@coaching-culture/types";
import axios from "axios";
import { useMutation, useQuery, useQueryClient } from "react-query";

const developmentNotesKey = (relationshipId: string) =>
  ["development-notes", relationshipId] as const;

const getDevelopmentNotes = (relationshipId: string) =>
  axios
    .get<DevelopmentNoteDto[]>(
      `/api/v2/relationships/${relationshipId}/development-notes`,
    )
    .then(({ data }) => data);

export const useDevelopmentNotes = (relationshipId: string | null) =>
  useQuery(
    developmentNotesKey(relationshipId ?? ""),
    () => getDevelopmentNotes(relationshipId as string),
    { enabled: !!relationshipId },
  );

const createDevelopmentNote = (cmd: CreateDevelopmentNoteCommand) =>
  axios.post(
    `/api/v2/relationships/${cmd.relationshipId}/development-notes`,
    { body: cmd.body },
  );

export const useCreateDevelopmentNote = () => {
  const qc = useQueryClient();
  return useMutation(createDevelopmentNote, {
    onSuccess: (_, cmd) =>
      qc.invalidateQueries(developmentNotesKey(cmd.relationshipId)),
  });
};
